export const SET_ERROR_MESSAGE = 'error/SET_ERROR_MESSAGE';
export const POST_ERROR_MESSAGE = 'error/POST_ERROR_MESSAGE';

export const RESET_ERROR_MESSAGE = 'error/RESET_ERROR_MESSAGE';
export const POST_RESET_ERROR = 'error/POST_RESET_ERROR';